import React from 'react';
import { Menu as MenuPrimitive } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

export default function MenuItem({ text, isSelected, onClick }) {
  return (
    <MenuPrimitive.Item>
      {({ active }) => {
        return (
          <span
            className={twMerge(
              active
                ? 'bg-gray-100 text-gray-900 rounded-md cursor-pointer'
                : 'text-gray-700',
              isSelected ? 'text-primary' : '',
              'block py-2 text-sm px-2',
            )}
            onClick={onClick}
          >
            {text}
          </span>
        );
      }}
    </MenuPrimitive.Item>
  );
}
